<interacta-user-notification [notification]="notification()">
    <div class="mt-8 flex items-center space-x-4">
        @if (feedbackTaskFromStateStyle(); as style) {
            <interacta-workflow-state-badge
                [colorClass]="style.background"
                [rounded]="'leaf'"
                [size]="'small'"
                [workflowStateName]="style.label | translate"
            />
        }
        <interacta-icon class="size-20" [icon]="'arrow-right'" />
        @if (feedbackTaskToStateStyle(); as style) {
            <interacta-workflow-state-badge
                [colorClass]="style.background"
                [rounded]="'leaf'"
                [size]="'small'"
                [workflowStateName]="style.label | translate"
            />
        }
    </div>
</interacta-user-notification>
